import React from 'react';
import xtend from 'xtend';
import { hasPermission } from '../lib/components/form/RestrictedComponent';

import Manage from '../metadata/Manage'

export default function managementRoute (api, socket, opts, match) {
    return function (props) {
        let sharedProps = xtend(props, { disabled: {
            ott: !hasPermission('manage_ott.read')
        }})
        return <Manage {...sharedProps}/>;
    };
};
